import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Image = createReactComponent("Image", ["svg", defaultAttributes, [["rect", {
  x: "3",
  y: "3",
  width: "18",
  height: "18",
  rx: "2",
  ry: "2",
  key: "1sylwi"
}], ["circle", {
  cx: "8.5",
  cy: "8.5",
  r: "1.5",
  key: "118yen"
}], ["polyline", {
  points: "21 15 16 10 5 21",
  key: "u5mf50"
}]]]);
export default Image;